enum ToolType {
  Brush = "Brush",
  Bucket = "Bucket",
  Spray = "Spray",
  Splatter = "Splatter",
  Eraser = "Eraser",
  Zig = "Zig",
}
export default ToolType;
